/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { Header } from "@/components/Header";
import { useTranslation } from "react-i18next";
import { CssHome, CssQuadro, CssSuvinil, CssInstagram, CssEcom, CssFim} from "./css";
import ReactHtmlParser from "html-react-parser";
import { Footer } from "@/components/Footer";

// CssHome
import setaAzul from "@/assets/cases/conteudoSocial/setaAzul.png";

// Home
import capaTransmissao from "@/assets/cases/transmissaoAoVivo/capa.gif";
import logoTransmissao from "@/assets/cases/transmissaoAoVivo/logo-transmissao.png";
import vectorZ from "@/assets/cases/transmissaoAoVivo/vectorZ.png";

// Quadro
import quadro from "@/assets/cases/transmissaoAoVivo/quadro.jpg";

// Suvinil
import card1Suvinil1 from "@/assets/cases/transmissaoAoVivo/card1-1.jpg";
import card1Suvinil2 from "@/assets/cases/transmissaoAoVivo/card1-2.jpg";
import card1Suvinil3 from "@/assets/cases/transmissaoAoVivo/card1-3.jpg";
import card1Suvinil4 from "@/assets/cases/transmissaoAoVivo/card1-4.jpg";

import card2Suvinil1 from "@/assets/cases/transmissaoAoVivo/card2-1.jpg";
import card2Suvinil2 from "@/assets/cases/transmissaoAoVivo/card2-2.jpg";
import card2Suvinil3 from "@/assets/cases/transmissaoAoVivo/card2-3.jpg";
import card2Suvinil4 from "@/assets/cases/transmissaoAoVivo/card2-4.jpg";

import celularSuvinil from "@/assets/cases/transmissaoAoVivo/celular-suvinil.png";
import vectorAzul from "@/assets/cases/transmissaoAoVivo/vectorAzul.png";
import vetorVazado from "@/assets/cases/transmissaoAoVivo/vetorVazado.png";

//Instagram
import postSuvinil1 from "@/assets/cases/transmissaoAoVivo/postSuvinil1.png";
import postSuvinil2 from "@/assets/cases/transmissaoAoVivo/postSuvinil2.gif";
import postSuvinil3 from "@/assets/cases/transmissaoAoVivo/postSuvinil3.png";
import postSuvinil4 from "@/assets/cases/transmissaoAoVivo/postSuvinil4.gif";
import postSuvinil5 from "@/assets/cases/transmissaoAoVivo/postSuvinil5.png";
import postSuvinil6 from "@/assets/cases/transmissaoAoVivo/postSuvinil6.gif";
import postSuvinil7 from "@/assets/cases/transmissaoAoVivo/postSuvinil7.png";
import postSuvinil8 from "@/assets/cases/transmissaoAoVivo/postSuvinil8.gif";
import postSuvinil9 from "@/assets/cases/transmissaoAoVivo/postSuvinil9.png";
import postSuvinil10 from "@/assets/cases/transmissaoAoVivo/postSuvinil10.gif";
import vetorVermelhoEsquerdo from "@/assets/cases/transmissaoAoVivo/vetorVermelhoEsquerdo.png";

//Ecom
import noteEcom from "@/assets/cases/transmissaoAoVivo/note.png";
import vectorCima from "@/assets/cases/transmissaoAoVivo/vectorCima.png";
import vectorBaixo from "@/assets/cases/transmissaoAoVivo/vectorBaixo.png";
import vetorEsquerdo from "@/assets/cases/transmissaoAoVivo/vetorEsquerdo.png";

//Fim
import fotoFim1 from "@/assets/cases/transmissaoAoVivo/foto1.jpg";
import fotoFim2 from "@/assets/cases/transmissaoAoVivo/foto2.jpg";
import fotoFim3 from "@/assets/cases/transmissaoAoVivo/foto3.jpg";
import vetorFim from "@/assets/cases/transmissaoAoVivo/vetorFim.png";

const CasesTransmissaoAoVivo = () => {
	const { t } = useTranslation();

	/* ========================= HOME ========================= */

	const homeRef = useRef(null);
	const capaRef = useRef(null);

	const [animateHome, setAnimateHome] = useState(false);
	const [animateCapa, setAnimateCapa] = useState(false);

	useEffect(() => {
		const observerOptions = {
			root: null,
			threshold: 0.25,
		};

		const observerHome = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					if (entry.target === homeRef.current) {
						setAnimateHome(true);
					}

					if (entry.target === capaRef.current) {
						setAnimateCapa(true);
					}
				}
			});
		}, observerOptions);

		if (homeRef.current) observerHome.observe(homeRef.current);
		if (capaRef.current) observerHome.observe(capaRef.current);
		
	}, []);

	/* ========================= QUADRO ========================= */

	const quadroRef = useRef(null);

	const [animateQuadro, setAnimateQuadro] = useState(false);

	useEffect(() => {
		const observerOptions = {
			root: null,
			threshold: 0.25,
		};

		const observerQuadro = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					if (entry.target === quadroRef.current) {
						setAnimateQuadro(true);
					}
				}
			});
		}, observerOptions);

		if (quadroRef.current) observerQuadro.observe(quadroRef.current);
		
	}, []);

	/* ========================= SUVINIL ========================= */

	const suvinilRef = useRef(null);
	const [animateSuvinil, setAnimateSuvinil] = useState(false);

	useEffect(() => {
		const observerOptions = {
			root: null,
			threshold: 0.25,
		};

		const observerSuvinil = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					if (entry.target === suvinilRef.current) {
						setAnimateSuvinil(true);
					}
				}
			});
		}, observerOptions);

		if (suvinilRef.current) observerSuvinil.observe(suvinilRef.current);
	
	}, []);

	/* ========================= INSTAGRAM ========================= */

	const instagramRef = useRef(null);
	const [animateInstagram, setAnimateInstagram] = useState(false);

	useEffect(() => {
		const observerOptions = {
			root: null,
			threshold: 0.2,
		};

		const observerInstagram = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					if (entry.target === instagramRef.current) {
						setAnimateInstagram(true);
					}
				}
			});
		}, observerOptions);

		if (instagramRef.current) observerInstagram.observe(instagramRef.current);

	
	}, []);

	/* ========================= ECOM ========================= */

	const ecomRef = useRef(null);
	const [animateEcom, setAnimateEcom] = useState(false);

	useEffect(() => {
		const observerOptions = {
			root: null,
			threshold: 0.2,
		};

		const observerEcom = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					if (entry.target === ecomRef.current) {
						setAnimateEcom(true);
					}
				}
			});
		}, observerOptions);

		if (ecomRef.current) observerEcom.observe(ecomRef.current);

		
	}, []);

	/* ========================= FIM ========================= */

	const fimRef = useRef(null);
	const [animateFim, setAnimateFim] = useState(false);

	useEffect(() => {
		const observerOptions = {
			root: null,
			threshold: 0.22,
		};

		const observerFim = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					if (entry.target === fimRef.current) {
						setAnimateFim(true);
					}
				}
			});
		}, observerOptions);

		if (fimRef.current) observerFim.observe(fimRef.current);

		
	}, []);

	return (
		<>
			<Helmet>
				<title>Zest Ag | Cases | Transmissão Ao Vivo</title>

				<link rel="shortcut icon" href="https://zest.ag/favicon.png?v=3" />
				<link rel="icon" type="image/png" href="https://zest.ag/favicon.png?v=3" />
				<link rel="apple-touch-icon" href="https://zest.ag/favicon.png?v=3" />

				<meta name="description" content="Zest AG - The full responsa agency" />
				<meta
					name="keywords"
					content="Zest One, Agência de marketing, negócios e interesses do cliente, inbound"
				/>

				<meta property="og:url" content="https://zest.ag/CasesTransmissaoAoVivo" />
				<meta property="og:type" content="website" />
				<meta property="og:title" content="Zest Ag | Cases | Transmissão Ao Vivo" />
				<meta property="og:description" content="Zest Ag - The full responsa agency" />
				<meta property="og:image" content="https://zest.ag/avatar.jpg" />
			</Helmet>

			<Header />
			<div className="clear" />

			{/* ========================= HOME ========================= */}
			<CssHome>
				{/* ========================= PARTE 1 - HOME ========================= */}
				<section
					ref={homeRef}
					className={`caseHero ${animateHome ? "animateParte1" : ""}`}
				>
					<div className="caseContainer">	
						<div className="transmissaoHeroContent">
							<img
								src={logoTransmissao}
								alt="Transmissões ao vivo"
								className="transmissaoLogo animLogoLeft"
							/>

							<div className="transmissaoText animTextBottom">
								{ReactHtmlParser(t("casesTransmissaoAoVivo.texto"))}
							</div>

							<img
								src={vectorZ}
								alt=""
								className="transmissaoVectorZ animVectorRight"
							/>
						</div>
					</div>
				</section>

				{/* ========================= PARTE 2 - CAPA ========================= */}
				<section
					ref={capaRef}
					className={`transmissaoCapaSection ${animateCapa ? "animateParte2" : ""}`}
				>
					<div className="transmissaoCapaWrap">
						<img
							src={capaTransmissao}
							alt="Transmissões ao vivo"
							className="transmissaoCapa animCapaBottom"
						/>
					</div>
				</section>
			</CssHome>

			{/* ========================= PARTE 3 - QUADRO ========================= */}
			<CssQuadro>
				<section
					ref={quadroRef}
					className={`quadroSection ${animateQuadro ? "animateQuadro" : ""}`}
				>
					<div className="quadroContainer">
						<div className="quadroTexto animQuadroTexto">
							{ReactHtmlParser(t("casesTransmissaoAoVivo.quadroTexto"))}
						</div>

						<img
							src={quadro}
							alt="Transmissões ao vivo"
							className="quadroImg animQuadroImg"
						/>
					</div>
				</section>
			</CssQuadro>

			{/* ========================= PARTE 4 - SUVINIL ========================= */}
			<CssSuvinil>
				<section
					ref={suvinilRef}
					className={`suvinilSection ${animateSuvinil ? "animateSuvinil" : ""}`}
				>
					<div className="suvinilContainer">
						<div className="suvinilTexto animSuvinilTextLeft">
							<p>{ReactHtmlParser(t("casesTransmissaoAoVivo.suvinilTexto"))}</p>
						</div>

						<div className="suvinilStat suvinilStat150 animSuvinilStat150">
							<strong>+10</strong>
							<span>{t("casesTransmissaoAoVivo.suvinil150Legenda")}</span>
						</div>

						<div className="suvinilCardsLeft">
							<img
								src={card1Suvinil1}
								alt=""
								className="suvinilCard suvinilCardLeft suvinilCard1 suvinilCard1A animSuvinilCard1"
							/>

							<img
								src={card1Suvinil2}
								alt=""
								className="suvinilCard suvinilCardLeft suvinilCard2 suvinilCard1B animSuvinilCard1"
							/>

							<img
								src={card1Suvinil3}
								alt=""
								className="suvinilCard suvinilCardLeft suvinilCard3 suvinilCard1C animSuvinilCard1"
							/>

							<img
								src={card1Suvinil4}
								alt=""
								className="suvinilCard suvinilCardLeft suvinilCard4 suvinilCard1D animSuvinilCard1"
							/>
						</div>

						<img
							src={celularSuvinil}
							alt=""
							className="suvinilCelular animSuvinilCelular"
						/>

						<img
							src={vectorAzul}
							alt=""
							className="suvinilVectorAzul animSuvinilVector"
						/>

						<img
							src={vetorVazado}
							alt=""
							className="suvinilVetorVazado animSuvinilVector"
						/>

						<div className="suvinilCardsRight">
							<img
								src={card2Suvinil1}
								alt=""
								className="suvinilCard suvinilCardRight suvinilCard5 suvinilCard2A animSuvinilCard2"
							/>

							<img
								src={card2Suvinil2}
								alt=""
								className="suvinilCard suvinilCardRight suvinilCard6 suvinilCard2B animSuvinilCard2"
							/>

							<img
								src={card2Suvinil3}
								alt=""
								className="suvinilCard suvinilCardRight suvinilCard7 suvinilCard2C animSuvinilCard2"
							/>

							<img
								src={card2Suvinil4}
								alt=""
								className="suvinilCard suvinilCardRight suvinilCard8 suvinilCard2D animSuvinilCard2"
							/>
						</div>

						<div className="suvinilStat suvinilStat100 animSuvinilStat100">
							<strong>+100M</strong>
							<span>{t("casesTransmissaoAoVivo.suvinil100Legenda")}</span>
						</div>
					</div>
				</section>
			</CssSuvinil>

			{/* ========================= PARTE 5 - INSTAGRAM ========================= */}
			<CssInstagram>
				<section
					ref={instagramRef}
					className={`instagramSection ${animateInstagram ? "animateInstagram" : ""}`}
				>
					<div className="instagramContainer">
						<img
							src={vetorVermelhoEsquerdo}
							alt=""
							className="instagramVetorVermelho animInstagramVetor"
						/>

						<div className="instagramDescricao animInstagramDescricao">
							<p>{ReactHtmlParser(t("casesTransmissaoAoVivo.instagramTexto"))}</p>
						</div>

						<div className="instagramGrid">
							<div className="instagramPostBox instagramPost1 animInstagramPostTop">
								<img src={postSuvinil1} alt="" className="instagramPostImg" />
							</div>

							<div className="instagramPostBox instagramPost2 animInstagramPostTop">
								<img src={postSuvinil2} alt="" className="instagramPostImg" />
							</div>

							<div className="instagramPostBox instagramPost3 animInstagramPostTop">
								<img src={postSuvinil3} alt="" className="instagramPostImg" />
							</div>

							<div className="instagramPostBox instagramPost4 animInstagramPostTop">
								<img src={postSuvinil4} alt="" className="instagramPostImg" />
							</div>

							<div className="instagramPostBox instagramPost5 animInstagramPostTop instagramPostHideMobile">
								<img src={postSuvinil5} alt="" className="instagramPostImg" />
							</div>

							<div className="instagramPostBox instagramPost6 animInstagramPostBottom">
								<img src={postSuvinil6} alt="" className="instagramPostImg" />
							</div>

							<div className="instagramPostBox instagramPost7 animInstagramPostBottom">
								<img src={postSuvinil7} alt="" className="instagramPostImg" />
							</div>

							<div className="instagramPostBox instagramPost8 animInstagramPostBottom">
								<img src={postSuvinil8} alt="" className="instagramPostImg" />
							</div>

							<div className="instagramPostBox instagramPost9 animInstagramPostBottom">
								<img src={postSuvinil9} alt="" className="instagramPostImg" />
							</div>

							<div className="instagramPostBox instagramPost10 animInstagramPostBottom instagramPostHideMobile">
								<img src={postSuvinil10} alt="" className="instagramPostImg" />
							</div>
						</div>
					</div>
				</section>
			</CssInstagram>

			{/* ========================= PARTE 6 - ECOM ========================= */}
			<CssEcom>
				<section
					ref={ecomRef}
					className={`ecomSection ${animateEcom ? "animateEcom" : ""}`}
				>
					<div className="ecomContainer">
						<img
							src={vectorCima}
							alt=""
							className="ecomVectorCima animEcomVectorCima"
						/>

						<img
							src={vectorBaixo}
							alt=""
							className="ecomVectorBaixo animEcomVectorBaixo"
						/>

						<img
							src={vetorEsquerdo}
							alt=""
							className="ecomVetorEsquerdo animEcomVetorEsquerdo"
						/>

						<div className="ecomTexto ecomTextoTopo animEcomTextoLeft">
							{ReactHtmlParser(t("casesTransmissaoAoVivo.ecomTextoTopo"))}
						</div>

						<div className="ecomTexto ecomTextoBaixo animEcomTextoBottom">
							{ReactHtmlParser(t("casesTransmissaoAoVivo.ecomTextoBaixo"))}
						</div>

						<div className="ecomStat ecomStatLeft animEcomStatLeft">
							<strong>+1.000MM</strong>
							<span>{t("casesTransmissaoAoVivo.ecom150LegendaEsquerda")}</span>
						</div>

						<div className="ecomStat ecomStatRight animEcomStatRight">
							<strong>+880K</strong>
							<span>{t("casesTransmissaoAoVivo.ecom150LegendaDireita")}</span>
						</div>

						<img
							src={noteEcom}
							alt=""
							className="ecomNote animEcomNote"
						/>
					</div>
				</section>
			</CssEcom>


			{/* ========================= PARTE 7 - FIM ========================= */}
			<CssFim>
				<section
					ref={fimRef}
					className={`fimSection ${animateFim ? "animateFim" : ""}`}
				>
					<img
							src={vetorFim}
							alt=""
							className="fimVetor animFimVetor"
						/>
					<div className="fimContainer">
						

						<div className="fimTexto animFimTexto">
							{ReactHtmlParser(t("casesTransmissaoAoVivo.fimTexto"))}
						</div>

						<div className="fimFotos">
							<img
								src={fotoFim1}
								alt=""
								className="fimFoto fimFoto1 animFimFoto"
							/>

							<img
								src={fotoFim2}
								alt=""
								className="fimFoto fimFoto2 animFimFoto"
							/>

							<img
								src={fotoFim3}
								alt=""
								className="fimFoto fimFoto3 animFimFoto"
							/>
						</div>
					</div>
				</section>

				<div className="caseTop">
					<a href="/CasesCampanhas" className="caseNav caseNavHome">
						<img src={setaAzul} alt="" />
						<span>{t("botoes.voltar")}</span>
					</a>

					<a href="/CasesRealTime" className="caseNav caseNavNext">
						<span>{t("casesConteudoSocial.proximoCase")}</span>
						<img src={setaAzul} alt="" />
					</a>
				</div>
			</CssFim>

			<div className="clear" />
			<Footer />
		</>
	);
};

export default CasesTransmissaoAoVivo;